export default function MasterDataAccordion({ accordionConfig = [] }) {
  return (
    <div className="accordion shadow-sm" id="accordionDashboard">
      {accordionConfig.map((item, index) => {
        const Component = item.component;
        const isFirstItem = index === 0;

        return (
          <div key={item.id} className={item.className}>
            <h2 className="accordion-header" id={`heading${item.id}`}>
              <button
                className={`accordion-button ${
                  !isFirstItem ? "collapsed" : ""
                } fw-bold ${
                  isFirstItem ? "text-primary" : "text-dark"
                } bg-white`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${item.id}`}
                aria-expanded={isFirstItem}
                aria-controls={`collapse${item.id}`}
              >
                <i
                  className={`fa ${item.icon} me-2 ${
                    item.id === "leaderboard"
                      ? "text-warning"
                      : item.id === "statistics"
                      ? "text-info"
                      : "text-success"
                  }`}
                ></i>
                {item.title}
              </button>
            </h2>
            <div
              id={`collapse${item.id}`}
              className={`accordion-collapse collapse ${
                isFirstItem ? "show" : ""
              }`}
              aria-labelledby={`heading${item.id}`}
              data-bs-parent="#accordionDashboard"
            >
              {Component ? (
                <Component {...item.props} />
              ) : (
                <div className="accordion-body bg-light text-muted text-center py-4">
                  Komponen belum tersedia
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

